import React from 'react'
import PropTypes from 'prop-types'
import * as Icons from 'ui/icons'
import { WhenModelValue } from '@morningtrain/react-resources'

function PlayButton ({ isPlaying, onClick }) {
  const handleOnClick = (e) => {
    if (typeof onClick === 'function') {
      onClick(e)
    }
  }

  return (
    <button onClick={e => handleOnClick(e)} className='border-none text-white bg-primary-500 w-16 h-16 rounded-full appearance-none outline-none flex items-center justify-center hover:bg-primary-400 focus:bg-primary-600'>
      <WhenModelValue name='is_toggle_running' condition>
        <Icons.Stop className='w-4 h-4' />
      </WhenModelValue>
      <WhenModelValue name='is_toggle_running' condition={false}>
        <Icons.Play className='w-5 h-5 ml-1' />
      </WhenModelValue>
    </button>
  )
}

PlayButton.defaultProps = {
  isPlaying: false
}

PlayButton.propTypes = {
  onClick: PropTypes.func,
  /**
     * Will display a play icon if set to false
     * and a stop icon if set to true
     */
  isPlaying: PropTypes.bool
}

export default PlayButton
